import {
    FlagsData,
    notifyLoginLogoutDTO,
    subscribeData,
    subscribeMobileDeviceDTO,
    unsubscribeData,
    unsubscribeMobileDeviceDTO,
    updateData,
} from '.';

export const HEALTH_CHECK = {
    SOCKETS_WORKING: 'HEALTH_CHECK.SOCKETS_WORKING',
    SOCKETS_NOT_WORKING: 'HEALTH_CHECK.SOCKETS_NOT_WORKING',

    ORGANIZATION_SERVICE_STATUS: 'HEALTH_CHECK.ORGANIZATION_SERVICE_STATUS',
    RESIDENTS_SERVICE_STATUS: 'HEALTH_CHECK.RESIDENTS_SERVICE_STATUS',

    SUBSCRIBE_NOTIFICATION_REQUEST: 'HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_REQUEST',
    SUBSCRIBE_NOTIFICATION_SUCCESS: 'HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_SUCCESS',
    SUBSCRIBE_NOTIFICATION_FAILURE: 'HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FAILURE',
    SUBSCRIBE_NOTIFICATION_FORBIDDEN: 'HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FORBIDDEN',

    UN_SUBSCRIBE_NOTIFICATION_REQUEST: 'HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_REQUEST',
    UN_SUBSCRIBE_NOTIFICATION_SUCCESS: 'HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_SUCCESS',
    UN_SUBSCRIBE_NOTIFICATION_FAILURE: 'HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_FAILURE',

    RE_SUBSCRIBE_NOTIFICATION_REQUEST: 'HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_REQUEST',
    RE_SUBSCRIBE_NOTIFICATION_SUCCESS: 'HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_SUCCESS',
    RE_SUBSCRIBE_NOTIFICATION_FAILURE: 'HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_FAILURE',

    SAVE_PNS_MOBILE_ID: 'HEALTH_CHECK.SAVE_PNS_MOBILE_ID',

    NOTIFY_LOGIN_LOGOUT_REQUEST: 'HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_REQUEST',
    NOTIFY_LOGIN_LOGOUT_SUCCESS: 'HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_SUCCESS',
    NOTIFY_LOGIN_LOGOUT_FAILURE: 'HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_FAILURE',

    NEED_TO_NOTIFY_LOGIN: 'HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN',
    MAIN_PAGE_CHANGED: 'HEALTH_CHECK.MAIN_PAGE_CHANGED',

    ON_CHANGE_FEATURE_FLAGS: 'HEALTH_CHECK.ON_CHANGE_FEATURE_FLAGS',

    SUBSCRIBE_USER_MOBILE_DEVICE_REQUEST: 'HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_REQUEST',
    SUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS: 'HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS',
    SUBSCRIBE_USER_MOBILE_DEVICE_FAILURE: 'HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_FAILURE',

    UNSUBSCRIBE_USER_MOBILE_DEVICE_REQUEST: 'HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_REQUEST',
    UNSUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS: 'HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS',
    UNSUBSCRIBE_USER_MOBILE_DEVICE_FAILURE: 'HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_FAILURE',

    SET_THIS_MOBILE_DEVICE_AS_TAG: 'HEALTH_CHECK.SET_THIS_MOBILE_DEVICE_AS_TAG',
};

export interface ISubscribeNotification {
    type: typeof HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_REQUEST;
    payload: subscribeData;
}

export interface ISubscribeNotificationSuccess {
    type: typeof HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_SUCCESS;
    payload: subscribeData;
}

export interface ISubscribeNotificationFailure {
    type: typeof HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FAILURE;
    payload: any;
}

export interface ISubscribeNotificationForbidden {
    type: typeof HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FORBIDDEN;
    payload: string;
}

export interface ISubscribeNotification {
    type: typeof HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_REQUEST;
    payload: subscribeData;
}

export interface ISubscribeNotificationSuccess {
    type: typeof HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_SUCCESS;
    payload: subscribeData;
}

export interface ISubscribeNotificationFailure {
    type: typeof HEALTH_CHECK.SUBSCRIBE_NOTIFICATION_FAILURE;
    payload: any;
}

export interface IUnSubscribeNotification {
    type: typeof HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_REQUEST;
    payload: unsubscribeData;
}

export interface IUnSubscribeNotificationSuccess {
    type: typeof HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_SUCCESS;
    payload: unsubscribeData;
}

export interface IUnSubscribeNotificationFailure {
    type: typeof HEALTH_CHECK.UN_SUBSCRIBE_NOTIFICATION_FAILURE;
    payload: any;
}

export interface IRESubscribeNotification {
    type: typeof HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_REQUEST;
    payload: updateData;
}

export interface IRESubscribeNotificationSuccess {
    type: typeof HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_SUCCESS;
    payload: updateData;
}

export interface IRESubscribeNotificationFailure {
    type: typeof HEALTH_CHECK.RE_SUBSCRIBE_NOTIFICATION_FAILURE;
    payload: any;
}

export interface INotifyLoginLogoutRequest {
    type: typeof HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_REQUEST;
    payload: { isLogin: boolean; value: notifyLoginLogoutDTO };
}

export interface INotifyLoginLogoutSuccess {
    type: typeof HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_SUCCESS;
    payload: boolean;
}

export interface INotifyLoginLogoutFailure {
    type: typeof HEALTH_CHECK.NOTIFY_LOGIN_LOGOUT_FAILURE;
    payload: any;
}

export interface ISaveDeviceInfo {
    type: typeof HEALTH_CHECK.SAVE_PNS_MOBILE_ID;
    payload: subscribeData;
}

export interface ISocketsWorking {
    type: typeof HEALTH_CHECK.SOCKETS_WORKING;
    payload: any;
}

export interface ISocketsNOTWorking {
    type: typeof HEALTH_CHECK.SOCKETS_NOT_WORKING;
    payload: any;
}

export interface IOrganizationServiceStatus {
    type: typeof HEALTH_CHECK.ORGANIZATION_SERVICE_STATUS;
    isAlive: boolean;
}

export interface IResidentsServiceStatus {
    type: typeof HEALTH_CHECK.RESIDENTS_SERVICE_STATUS;
    isAlive: boolean;
}
export interface IChangeFeatureFlags {
    type: typeof HEALTH_CHECK.ON_CHANGE_FEATURE_FLAGS;
    payload: FlagsData;
}

export interface INeedNotifyLogin {
    type: typeof HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN;
}

export interface IMainPageChanged {
    type: typeof HEALTH_CHECK.MAIN_PAGE_CHANGED;
    payload: boolean;
}
export interface ISubscribeUserMobileDeviceRequest {
    type: typeof HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_REQUEST;
    payload: subscribeMobileDeviceDTO;
}

export interface ISubscribeUserMobileDeviceSuccess {
    type: typeof HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS;
    payload: subscribeMobileDeviceDTO;
}

export interface ISubscribeUserMobileDeviceFailure {
    type: typeof HEALTH_CHECK.SUBSCRIBE_USER_MOBILE_DEVICE_FAILURE;
    payload: any;
}

export interface IUnSubscribeUserMobileDeviceRequest {
    type: typeof HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_REQUEST;
    payload: unsubscribeMobileDeviceDTO;
}

export interface IUnSubscribeUserMobileDeviceSuccess {
    type: typeof HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_SUCCESS;
    payload: unsubscribeMobileDeviceDTO;
}

export interface IUnSubscribeUserMobileDeviceFailure {
    type: typeof HEALTH_CHECK.UNSUBSCRIBE_USER_MOBILE_DEVICE_FAILURE;
    payload: any;
}

export interface ISetUserMobileDeviceAsTag {
    type: typeof HEALTH_CHECK.SET_THIS_MOBILE_DEVICE_AS_TAG;
}

export type HealthCheckActionTypes =
    | ISetUserMobileDeviceAsTag
    | ISaveDeviceInfo
    | ISocketsNOTWorking
    | ISocketsWorking
    | IResidentsServiceStatus
    | IOrganizationServiceStatus
    | IChangeFeatureFlags
    | INeedNotifyLogin
    | IMainPageChanged;
